import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { appLogo } from "../../assets";
import appcolors from "../../constants/Colors";
import { t } from "i18next";
import { CURRENCY } from "../../constants/Variables";

const InvoicePDF = ({ open, onClose, invoiceData }) => {
  const defaultData = {
    invoiceNumber: "INV-2024-001",
    invoiceDate: new Date().toLocaleDateString(),
    customer: {
      name: "John Doe",
      email: "john.doe@example.com",
      phone: "+1 (555) 123-4567",
    },
    subscription: {
      name: "Premium Plan",
      duration: "1 Month",
      price: 99.99,
      total: 99.99,
    },
    paymentStatus: "Paid",
    transactionId: "TXN-2024-001",
  };

  const data = invoiceData || defaultData;

  const handlePrint = () => {
    window.print();
  };

  const handleDownload = () => {
    // Create a new window for PDF generation
    const printWindow = window.open("", "_blank");
    const printDocument = printWindow.document;

    printDocument.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Invoice</title>
          <style>
            @page {
              margin: 0;
              size: A4;
            }
            @media print {
              @page {
                margin: 20mm;
                size: A4;
              }
              body {
                margin: 20mm !important;
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
                }
                /* Hide browser headers and footers */
                html, body {
                margin: 0 8mm;
                height: 100%;
                overflow: hidden;
              }
            }
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 20px;
              background: white;
              color: black;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            .invoice-container {
              max-width: 800px;
              margin: 0 auto;
              padding: 20px;
              border: 2px solid #7922D8;
              border-radius: 8px;
            }
            .header {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              margin-bottom: 30px;
              border-bottom: 3px solid #7922D8;
              padding-bottom: 20px;
            }
            .company-info {
              display: flex;
              align-items: center;
              gap: 15px;
            }
            .logo {
              height: 60px;
              width: auto;
              max-width: 200px;
            }
            .company-details h2 {
              color: #7922D8;
              font-weight: bold;
              font-size: 24px;
              margin: 0 0 5px 0;
            }
            .company-details p {
              color: #868E96;
              font-size: 14px;
              margin: 0;
            }
            .invoice-title {
              text-align: right;
            }
            .invoice-title h1 {
              color: #7922D8;
              font-weight: bold;
              font-size: 36px;
              margin: 0 0 15px 0;
              text-transform: uppercase;
            }
            .invoice-details {
              color: #868E96;
              font-size: 14px;
              line-height: 1.5;
            }
            .invoice-details strong {
              color: #343A40;
            }
            .section {
              margin-bottom: 30px;
            }
            .section-title {
              color: #7922D8;
              font-weight: bold;
              font-size: 18px;
              margin-bottom: 15px;
              border-bottom: 2px solid #7922D8;
              padding-bottom: 5px;
            }
            .customer-info {
              margin-bottom: 25px;
            }
            .customer-name {
              font-weight: bold;
              font-size: 16px;
              margin-bottom: 8px;
              color: #343A40;
              text-transform: capitalize;
            }
            .customer-detail {
              color: #868E96;
              margin-bottom: 5px;
              font-size: 14px;
            }
            .subscription-box {
              background-color: #F3EBFF;
              padding: 20px;
              border-radius: 8px;
              border: 2px solid #7922D8;
            }
            .subscription-row {
              display: flex;
              justify-content: space-between;
              margin-bottom: 12px;
              padding: 8px 0;
              border-bottom: 1px solid #E0E0E0;
            }
            .subscription-row:last-child {
              border-bottom: none;
            }
            .subscription-label {
              font-weight: bold;
              color: #343A40;
            }
            .subscription-value {
              color: #343A40;
              text-transform: capitalize;
            }
            .status-paid {
              color: #04C982;
              font-weight: bold;
            }
            .status-pending {
              color: #EA9366;
              font-weight: bold;
            }
            .price-summary {
              border-top: 3px solid #7922D8;
              padding-top: 20px;
              margin-top: 20px;
            }
            .price-row {
              display: flex;
              justify-content: space-between;
              margin-bottom: 10px;
              padding: 5px 0;
            }
            .price-label {
              font-weight: bold;
              color: #343A40;
            }
            .price-value {
              color: #343A40;
            }
            .total-row {
              display: flex;
              justify-content: space-between;
              border-top: 2px solid #D6D6D7;
              padding-top: 15px;
              margin-top: 15px;
              font-weight: bold;
              font-size: 18px;
            }
            .total-label {
              color: #343A40;
            }
            .total-amount {
              color: #7922D8;
              font-size: 20px;
            }
            .footer {
              margin-top: 40px;
              padding-top: 20px;
              border-top: 2px solid #D6D6D7;
              text-align: center;
              color: #868E96;
              font-size: 14px;
            }
            .footer h3 {
              color: #7922D8;
              margin-bottom: 10px;
            }
            @media print {
              body { 
                margin: 0 !important; 
                padding: 0 !important;
              }
              .invoice-container { 
                border: none !important; 
                margin: 0 !important;
                padding: 20px !important;
              }
              .no-print { display: none !important; }
              /* Ensure no browser headers/footers */
              @page {
                margin: 0 !important;
                size: A4 !important;
              }
            }
          </style>
        </head>
        <body>
          <div class="invoice-container">
            <!-- Header -->
            <div class="header">
              <div class="company-info">
                <img src="${
                  appLogo.eazidayLogoNew
                }" alt="Company Logo" class="logo" />
                <div class="company-details">
                  <h2>Eaziday</h2>
                  <p>123 Business Street, Bucharest, Romania</p>
                  <p>support@eaziday.com</p>
                  <p>+40 735 383 792</p>
                  <p>CUI: RO49754252</p>
                </div>
              </div>
              
              <div class="invoice-title">
                <h1>Invoice</h1>
                <div class="invoice-details">
                  <p><strong>Invoice #:</strong> ${data.invoiceNumber}</p>
                  <p><strong>Start Date:</strong> ${data.invoiceStartDate}</p>
                  <p><strong>End Date:</strong> ${data.invoiceEndDate}</p>
                </div>
              </div>
            </div>

            <!-- Customer Information -->
            <div class="section">
              <div class="section-title">Bill To:</div>
              <div class="customer-info">
                <div class="customer-name">${data.customer.name}</div>
                <div class="customer-detail">${data.customer.email}</div>
                <div class="customer-detail">${data.customer.phone}</div>
              </div>
            </div>

            <!-- Subscription Details -->
            <div class="section">
              <div class="section-title">Subscription Details</div>
              <div class="subscription-box">
                <div class="subscription-row">
                  <span class="subscription-label">Plan:</span>
                  <span class="subscription-value">${
                    data.subscription.name
                  }</span>
                </div>
                <div class="subscription-row">
                  <span class="subscription-label">Duration:</span>
                  <span class="subscription-value">${
                    data.subscription.duration
                  }</span>
                </div>
                <div class="subscription-row">
                  <span class="subscription-label">Status:</span>
                  <span class="subscription-value ${
                    data.paymentStatus === "Paid"
                      ? "status-paid"
                      : "status-pending"
                  }">${data.paymentStatus}</span>
                </div>
                
              </div>
            </div>

            <!-- Price Summary -->
            <div class="price-summary">
              <div class="price-row">
                <span class="price-label">Subscription Price:</span>
                <span class="price-value">${CURRENCY} ${data.subscription.price.toFixed(
      2
    )}</span>
              </div>
            
              <div class="total-row">
                <span class="total-label">Total:</span>
                <span class="total-amount">${CURRENCY} ${data.subscription.price.toFixed(
      2
    )}</span>
              </div>
            </div>
          </div>
        </body>
      </html>
    `);

    printDocument.close();

    // Wait for content to load then print
    printWindow.onload = () => {
      printWindow.print();
      printWindow.close();
    };
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent sx={{ p: 0 }}>
        <Box id="invoice-content" sx={{ p: 5, backgroundColor: "white" }}>
          {/* Invoice Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              mb: 4,
              borderBottom: `3px solid ${appcolors.primary}`,
              pb: 2,
            }}
          >
            {/* Company Info */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Box
                component="img"
                src={appLogo.eazidayLogoNew}
                alt="Company Logo"
                sx={{ height: 60, width: "auto", maxWidth: 200 }}
              />
              <Box>
                <Box
                  sx={{
                    color: appcolors.primary,
                    fontWeight: "bold",
                    fontSize: "1.5rem",
                    mb: 0.5,
                  }}
                >
                  Eaziday
                </Box>
                <Box sx={{ color: appcolors.crayolaGrey, fontSize: "0.9rem" }}>
                  123 Business Street, Bucharest, Romania
                </Box>
                <Box sx={{ color: appcolors.crayolaGrey, fontSize: "0.9rem" }}>
                  info@eaziday.com
                </Box>
                <Box sx={{ color: appcolors.crayolaGrey, fontSize: "0.9rem" }}>
                  +40 735 383 792
                </Box>
                <Box sx={{ color: appcolors.crayolaGrey, fontSize: "0.9rem" }}>
                  CUI: RO49754252
                </Box>
              </Box>
            </Box>

            {/* Invoice Title */}
            <Box sx={{ textAlign: "right" }}>
              <Box
                sx={{
                  color: appcolors.primary,
                  fontWeight: "bold",
                  fontSize: "2.5rem",
                  mb: 1,
                  textTransform: "uppercase",
                }}
              >
                Invoice
              </Box>
              <Box sx={{ color: appcolors.crayolaGrey, fontSize: "0.9rem" }}>
                Invoice #: {data.invoiceNumber}
              </Box>
              <Box sx={{ color: appcolors.crayolaGrey, fontSize: "0.9rem" }}>
                Start Date: {data.invoiceStartDate}
              </Box>
              <Box sx={{ color: appcolors.crayolaGrey, fontSize: "0.9rem" }}>
                End Date: {data.invoiceEndDate}
              </Box>
            </Box>
          </Box>

          {/* Customer Info */}
          <Box sx={{ mb: 4 }}>
            <Box
              sx={{
                color: appcolors.primary,
                fontWeight: "bold",
                fontSize: "1.2rem",
                mb: 2,
                borderBottom: `2px solid ${appcolors.primary}`,
                pb: 1,
              }}
            >
              Bill To:
            </Box>
            <Box
              textTransform={"capitalize"}
              sx={{ fontWeight: "bold", fontSize: "1.1rem", mb: 1 }}
            >
              {data.customer.name}
            </Box>
            <Box sx={{ color: appcolors.crayolaGrey }}>
              {data.customer.email}
            </Box>
            <Box sx={{ color: appcolors.crayolaGrey }}>
              {data.customer.phone}
            </Box>
          </Box>

          {/* Subscription Details */}
          <Box sx={{ mb: 4 }}>
            <Box
              sx={{
                color: appcolors.primary,
                fontWeight: "bold",
                fontSize: "1.2rem",
                mb: 2,
                borderBottom: `2px solid ${appcolors.primary}`,
                pb: 1,
              }}
            >
              Subscription Details
            </Box>

            <Box
              sx={{
                backgroundColor: appcolors.primaryLight,
                p: 2.5,
                borderRadius: 1,
                border: `2px solid ${appcolors.primary}`,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 1.5,
                  pb: 1,
                  borderBottom: "1px solid #E0E0E0",
                }}
              >
                <Box sx={{ fontWeight: "bold" }}>Plan:</Box>
                <Box textTransform={"capitalize"}>{data.subscription.name}</Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 1.5,
                  pb: 1,
                  borderBottom: "1px solid #E0E0E0",
                }}
              >
                <Box sx={{ fontWeight: "bold" }}>Duration:</Box>
                <Box textTransform={"capitalize"}>
                  {data.subscription.duration}
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  // mb: 1.5,
                  // pb: 1,
                }}
              >
                <Box sx={{ fontWeight: "bold" }}>Status:</Box>
                <Box
                  textTransform={"capitalize"}
                  sx={{
                    color:
                      data.paymentStatus === "Paid"
                        ? appcolors.caribbeanGreen
                        : appcolors.tumbleweed,
                    fontWeight: "bold",
                  }}
                >
                  {data.paymentStatus}
                </Box>
              </Box>
            </Box>
          </Box>

          {/* Price Summary */}
          <Box
            sx={{
              borderTop: `3px solid ${appcolors.primary}`,
              pt: 2.5,
              mt: 2.5,
            }}
          >
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 1.5 }}
            >
              <Box sx={{ fontWeight: "bold" }}>Subscription Price:</Box>
              <Box>
                {CURRENCY} {data.subscription.price.toFixed(2)}
              </Box>
            </Box>
            {/* <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 1.5 }}
            >
              <Box sx={{ fontWeight: "bold" }}>Tax (9%):</Box>
              <Box>${(data.subscription.price * 0.09).toFixed(2)}</Box>
            </Box> */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                borderTop: `2px solid ${appcolors.softGrey}`,
                pt: 1.5,
                mt: 1.5,
                fontWeight: "bold",
                fontSize: "1.2rem",
              }}
            >
              <Box>Total:</Box>
              <Box
                sx={{
                  fontWeight: "bold",
                  fontSize: "1.3rem",
                  color: appcolors.primary,
                }}
              >
                {CURRENCY} {data.subscription.price.toFixed(2)}
              </Box>
            </Box>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button
          variant="outlined"
          onClick={handleDownload}
          sx={{
            borderColor: appcolors.primary,
            color: appcolors.primary,
            "&:hover": {
              borderColor: appcolors.primary,
              backgroundColor: appcolors.primaryLight,
            },
          }}
        >
          {t("download")}
        </Button>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            backgroundColor: appcolors.primary,
            "&:hover": {
              backgroundColor: appcolors.primary,
              opacity: 0.9,
            },
          }}
        >
          {t("close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InvoicePDF;
